import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=599e743d&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=599e743d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e743d",
  null
  
)

export default component.exports